import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {TextField,Grid,IconButton} from '@material-ui/core';
import {isEmpty} from 'lodash'
import DeleteIcon from '@material-ui/icons/Delete';
import IntlMessages from 'util/IntlMessages';
const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(0),
      //   width: '28ch',
      },
    },
  }));

function ChoooseDocument(props) {
    const classes = useStyles();
    const [Documentslist, setDocumentslist] = React.useState([]);
  console.log(props)
    React.useEffect(()=>{
        setDocumentslist(props.Documentslist)
     },[props.Documentslist])
    const onChangeAvK=(e)=>{
      let Documentslist1=props.Documentslist
      
      let index = isEmpty(props.Documentslist)?-1:props.Documentslist.findIndex(item=>{
        return `${item.id}_${item.isAvtal}` === e.target.value
      })
      console.log(index)
      if(index === -1){
        console.log(props.currentAvtalDocs.filter(item=>{
          return `${item.id}_${item.isAvtal}` === e.target.value
        }))
        Documentslist1.push(props.currentAvtalDocs.filter(item=>{
          return `${item.id}_${item.isAvtal}` === e.target.value
        })[0])
        setDocumentslist(Documentslist1)
        props.onChangeHandle({target:{
          value:Documentslist1,
          name:"Documentslist"
      }})
      }      
    }
    const removeThisDoc=(item2)=>{
      let Documentslist1=props.Documentslist
      let Arr = Documentslist1.filter(item=>{
        return parseInt(item.id) !== parseInt(item2)
      })
      setDocumentslist(Arr)
        props.onChangeHandle({target:{
          value:Arr,
          name:"Documentslist"
      }})
    }
    return (
      <form className={classes.root}>
        <div>
            {
                isEmpty(props.currentAvtalDocs)?"":
                <>
                <TextField
                    select
                    label={<IntlMessages id="input.Document.fetch"/>}
                    variant="outlined"
                    size="small"
                    name="Documentslist"
                    value={0}
                    fullWidth
                    onChange={onChangeAvK}
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{
                        shrink: true,
                      }}
                >
                    <option key="0" value={0}><IntlMessages id="All"/></option>
                    {props.currentAvtalDocs.map((option) => (
                        <option key={option.id} value={`${option.id}_${option.isAvtal}`}>
                            {option.Doc_Name}
                        </option>
                    ))}
                </TextField>
                {
                  isEmpty(props.Documentslist)?"":
                      props.Documentslist.map(item=>{
                        return (
                          <Grid container spacing={2}>
                            <Grid item xs={10}>{item.Doc_Name}</Grid>
                            <Grid item xs={2}>
                            <IconButton  style={{ padding: '0' }} color="secondary" component="span">
                              <DeleteIcon onClick={()=>removeThisDoc(item.id)}/>
                            </IconButton>
                            </Grid>
                          </Grid>
                        )
                      })
                }
                </>
            }
        </div>
        </form>
    );
}

export default ChoooseDocument;